import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Button } from '@mui/material'

import { ChangePasswordFormWrapper } from './change-password-form-wrapper.component'
import { ChangePasswordVerificatoinFormWrapper } from './change-password-verification-form-wrapper.component'

import { SPACES } from 'src/constants'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IChangePasswordFormWrapperProps {
  onClose: () => void
}

const ChangePasswordModalForms = ({ onClose }: IChangePasswordFormWrapperProps) => {
  const [searchParams] = useSearchParams()
  const changeToken = searchParams.get('change_password_token')
  const passwordOpen = searchParams.get('password_open')
  const [isVerificationForm, setIsVerificationForm] = useState(!!passwordOpen && !!changeToken)

  const handleFormChange = () => setIsVerificationForm((toggle) => !toggle)

  return (
    <>
      {!isVerificationForm ? (
        <ChangePasswordFormWrapper handleVerificationFormChange={handleFormChange} />
      ) : (
        <ChangePasswordVerificatoinFormWrapper onClose={onClose} />
      )}
      {changeToken && (
        <Button sx={{ mt: SPACES.xl }} onClick={handleFormChange} size="small">
          <HelperWrapper
            t={
              isVerificationForm
                ? 'password-change-change-button'
                : 'password-change-verification-button'
            }
            ns={ETranslationNs.UserProfile}
          />
        </Button>
      )}
    </>
  )
}

export { ChangePasswordModalForms }
